import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import i18n from './lang/i18n'

import comm from './store/common'
comm.ini();

// quasar
import Quasar from 'quasar/src/vue-plugin.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';
import quasarUserOptions from './quasar-user-options'
import { vfmPlugin } from 'vue-final-modal'
import Plugin from '@quasar/quasar-ui-qoverlay'
import '@quasar/quasar-ui-qoverlay/dist/index.css'

// VXETable
import VXETable from 'vxe-table'
import './styles/VxeTable.js';
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import VXETablePluginExportPDF from 'vxe-table-plugin-export-pdf'
import VXETablePluginRenderer from 'vxe-table-plugin-renderer'
VXETable.use(VXETablePluginExportXLSX);
VXETable.use(VXETablePluginExportPDF);
VXETable.use(VXETablePluginRenderer)
import 'vxe-table/lib/style.css'
import 'vxe-table-plugin-renderer/dist/style.css'

import i18n_table from './lang/i18n_table'

import VxeUIBase, { VxeUI } from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VxeUIPluginExportXLSX from '@vxe-ui/plugin-export-xlsx'
import VxeUIPluginExportPDF from '@vxe-ui/plugin-export-pdf'

VxeUI.use(VxeUIPluginExportXLSX)
VxeUI.use(VxeUIPluginExportPDF)

setTimeout(() => {
  // console.log(comm.sys_param);
  // Cookies.set('my_param', comm.my_param);
  // Cookies.set('sys_param', comm.sys_param);

  // LocalStorage.set('my_param', comm.my_param);
  // LocalStorage.set('sys_param', comm.sys_param);

  document.title = LocalStorage.getItem('my_param')["title"];
  // console.log(comm.sys_param);
}, 200);

// 设置表格语言
if (LocalStorage.getItem('my_param') == null) {
  setTimeout(() => {
    location.reload();
  }, 200);
}
i18n_table.global.locale = LocalStorage.getItem('my_param')['language'];
VXETable.setup({
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => i18n_table.global.t(key, args)
})

VXETable.setup({
  // 可选，对参数中的列头、校验提示..等进行自动翻译（只对支持国际化的有效）
  translate(key, args) {
    // 例如，只翻译 "app." 开头的键值
    // if (key && key.indexOf('table.') > -1) {
    return i18n.global.t(key, args)
    // }
    // return key
  }
})

// vue-datepicker日期组件
// import Datepicker from '@vuepic/vue-datepicker';
// import '@vuepic/vue-datepicker/dist/main.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'


// he-tree组件 可拖拽树
import { BaseTree, Draggable } from '@he-tree/vue'
import '@he-tree/vue/style/default.css'



// 引入ECharts
// import echarts from 'echarts';

// setTimeout(() => {
// console.log(comm.my_param, comm.user_info);
// sStor.set('myparam', comm.my_param);
// sStor.set('sysparam', comm.sys_param);

// if (!lStor.get("user_info")) {
//   // console.log(36);
//   lStor.set('user_info', comm.user_info, 30);
//   lStor.set('permission', comm.permission, 30);
// } else {
//   // console.log(40);
//   comm.user_info = lStor.get("user_info");
//   comm.permission = lStor.get("permission");
// }
// document.title = comm.my_param["title"];
// }, 500);

// wangEditor
import { i18nAddResources, i18nChangeLanguage, t } from '@wangeditor/editor';
import "./lang_wangeditor/zh_cn.js";
import "./lang_wangeditor/zh_tw.js";
i18nChangeLanguage(LocalStorage.getItem('my_param')['language'])

// 引入 img-vuer，安装插件
import gallery from 'img-vuer3'
import 'img-vuer3/dist/style.css'

// 导入公共样式
// import VxeUIBase from 'vxe-pc-ui'
import './styles/public.scss';
// import './styles/VxeTable.js';
// import 'vxe-pc-ui/es/style.css'

let app = createApp(App).use(Quasar, quasarUserOptions).use(Plugin).use(store).use(router).use(i18n).use(vfmPlugin).use(VXETable).use(VxeUIBase)
  // .use(Datepicker)
  .use(gallery, {
    swipeThreshold: 150, // 滑动阈值，默认值 100
    isIndexShow: true, // 是否显示图片序号
    useCloseButton: false, // 只通过右上角关闭键退出浏览
    preload: true, // 预加载同组图片
    sliderBackgroundColor: 'rgba(0,0,0,0.6)',
    sliderZIndex: 10001,
  });

app.component('VueDatePicker', VueDatePicker);

app.mount('#app');

// 系统全局配置
// 系统参数
app.config.globalProperties.$comm = comm;

// 表单字段样式
app.config.globalProperties.$form = [];
app.config.globalProperties.$form['outlined'] = 'false'; // 外部线条
app.config.globalProperties.$form['dense'] = 'dense';  // 是否紧凑
app.config.globalProperties.$form['filled'] = 'false'; // 是否填充
app.config.globalProperties.$form['is_label_in'] = false; // 标签是否在组件内部 // JL-NOTE 设为true时，样式有问题

// UI相关
app.config.globalProperties.$ui = [];
app.config.globalProperties.$ui['title_height'] = 50 + 36; // 标题总高度
app.config.globalProperties.$ui['function_btn_size'] = "0.7rem"; // 标题总高度

// 定义常量
// COOKIES有效时间
app.config.globalProperties.$COOKIS_TIMEOUT = '';
app.config.globalProperties.$IS_FRONT_BACK = false;

// 
// 保存数据时的有效性检查状态
app.config.globalProperties.$save_state = [];
app.config.globalProperties.$save_state['field'] = ""; // 异常字段名
app.config.globalProperties.$save_state['msg'] = ""; // 异常提示信息

// 默认操作
// 双击表格：查看（view）、修改（edit）
app.config.globalProperties.$operate = [];
app.config.globalProperties.$operate['table_dbclick'] = "view";
